import ServerCall from "../serverCall";

const getAnalytics = async (timeRange = "30d", startDate = "", endDate = "") => {
  const params = new URLSearchParams({ timeRange });
  if (startDate) params.set("startDate", startDate);
  if (endDate) params.set("endDate", endDate);
  const response = await ServerCall.get(`/admin/analytics?${params.toString()}`);
  return response;
};

const getUsers = async (page = 0, size = 20, filter = "all", search = "") => {
  const params = new URLSearchParams({ page, size, filter });
  if (search && search.trim()) params.set("search", search.trim());
  const response = await ServerCall.get(`/admin/users?${params.toString()}`);
  return response;
};

const getUserById = async (userId) => {
  const response = await ServerCall.get(`/admin/users/${userId}`);
  return response;
};

const verifyUser = async (userId) => {
  const response = await ServerCall.put(`/admin/users/${userId}/verify`);
  return response;
};

const unverifyUser = async (userId) => {
  const response = await ServerCall.put(`/admin/users/${userId}/unverify`);
  return response;
};

const rejectVerification = async (userId, reason) => {
  const params = reason ? `?reason=${encodeURIComponent(reason)}` : "";
  const response = await ServerCall.put(`/admin/users/${userId}/reject-verification${params}`);
  return response;
};

const adjustCredits = async (userId, amount) => {
  const response = await ServerCall.put(`/admin/users/${userId}/credits?amount=${amount}`);
  return response;
};

const banUser = async (userId) => {
  const response = await ServerCall.put(`/admin/users/${userId}/ban`);
  return response;
};

const unbanUser = async (userId) => {
  const response = await ServerCall.put(`/admin/users/${userId}/unban`);
  return response;
};

const getReports = async (page = 0, size = 20, status = "") => {
  const params = new URLSearchParams({ page, size });
  if (status && status !== "All") params.set("status", status.replace(/\s+/g, "_").toUpperCase());
  const response = await ServerCall.get(`/admin/reports?${params.toString()}`);
  return response;
};

const resolveReport = async (reportId, status) => {
  const response = await ServerCall.put(`/admin/reports/${reportId}/resolve?status=${status}`, {});
  return response;
};

const getMatches = async (page = 0, size = 20) => {
  const response = await ServerCall.get(`/admin/matches?page=${page}&size=${size}`);
  return response;
};

const getLogs = async (page = 0, size = 30) => {
  const response = await ServerCall.get(`/admin/logs?page=${page}&size=${size}`);
  return response;
};

const getBadgeCounts = async () => {
  const response = await ServerCall.get("/admin/badge-counts");
  return response;
};

const getTransactionLogs = async (
  page = 0,
  size = 15,
  category = "ALL",
  search = "",
  timeRange = "30d",
  startDate = "",
  endDate = "",
  country = ""
) => {
  const params = new URLSearchParams({ page, size });
  if (category && category !== "ALL") params.set("category", category);
  if (search && search.trim()) params.set("search", search.trim());
  if (timeRange) params.set("timeRange", timeRange);
  if (startDate) params.set("startDate", startDate);
  if (endDate) params.set("endDate", endDate);
  if (country && country !== "ALL") params.set("country", country);
  const response = await ServerCall.get(`/admin/analytics/transactions?${params.toString()}`);
  return response;
};

const getCoinsGraph = async (timeRange = "30d", startDate = "", endDate = "") => {
  const params = new URLSearchParams({ timeRange });
  if (startDate) params.set("startDate", startDate);
  if (endDate) params.set("endDate", endDate);
  const response = await ServerCall.get(`/admin/analytics/coins-graph?${params.toString()}`);
  return response;
};

const getSubscriptionGraph = async (timeRange = "30d", startDate = "", endDate = "") => {
  const params = new URLSearchParams({ timeRange });
  if (startDate) params.set("startDate", startDate);
  if (endDate) params.set("endDate", endDate);
  const response = await ServerCall.get(`/admin/analytics/subscription-graph?${params.toString()}`);
  return response;
};

const AdminService = {
  getAnalytics,
  getUsers,
  getUserById,
  verifyUser,
  unverifyUser,
  rejectVerification,
  adjustCredits,
  banUser,
  unbanUser,
  getReports,
  resolveReport,
  getMatches,
  getLogs,
  getBadgeCounts,
  getTransactionLogs,
  getCoinsGraph,
  getSubscriptionGraph,
};

export default AdminService;
